module.exports = __webpack_public_path__ + "img/bg_form_be_reprentative.3d196cc5.png";